<template>
  <component :is="customerData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="customerData === undefined">
      <h4 class="alert-heading">獲取客戶數據時出錯</h4>
      <div class="alert-body">
        找不到相關客戶記錄。請查看
        <b-link class="alert-link" :to="{ name: 'customer-list' }">
          客戶列表
        </b-link>
      </div>
    </b-alert>
    <customer-edit-tab-information
      v-if="customerData"
      :customer-data="customerData"
      :role-options="roleOptions"
      @refetch-data="refetchData"
      @update-customer-id="updateCustomerId"
      @fetch-options="fetchOptions"
      :in_modal="in_modal"
    />
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import customerStoreModule from "../customerStoreModule";
import customerEditTabInformation from "./customerEditTabInformation.vue";

export default {
  components: {
    customerEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  props: {
    in_modal: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const customerData = ref({ id: 0, is_active: 0, role_name: "客戶" });
    const customer = {
      id: 0,
      is_active: 0,
      role_name: "客戶",
    };

    const customer_APP_STORE_MODULE_NAME = "customer";

    if (!store.hasModule(customer_APP_STORE_MODULE_NAME))
      store.registerModule(customer_APP_STORE_MODULE_NAME, customerStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(customer_APP_STORE_MODULE_NAME))
        store.unregisterModule(customer_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "customer-create" || props.in_modal) {
        customerData.value = customer;
      } else {
        /*       customerData.value = {
          id: "C000031",
          name_cn: '李大文先生',
          name_en: 'Mr. Lee Tai Man',
          tel: "91234567",
          email: 'lee.tai.man@gmail.com',
          address:"沙田第一城",
          website:"http://www.youtubbe.com",
          created_at: "17-07-2022,13:00",
        }; */

        store
          .dispatch("customer/fetchCustomer", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            customerData.value = response.data.entity;
            customerData.value.role_name = "客戶";
            console.log(customerData.value);
          })
          .catch((error) => {
            console.log("error when fetching advance payment", error);
            if (error.response.status === 404) {
              customerData.value = undefined;
            }
          });
      }
    };

    const roleOptions = ref([]);

    const fetchRoles = () => {
      store.dispatch("app/fetchRoles", { user_type_id: 2 }).then((response) => {
        roleOptions.value = response.data.roles;
      });
    };

    const fetchOptions = () => {
      emit('fetch-options');
    };

    const updateCustomerId = (id) => {
      emit('update-customer-id', id);
    };

    onMounted(() => {
      refetchData();
      fetchRoles();
    });

    return {
      customerData,
      refetchData,
      roleOptions,
      fetchOptions,
      updateCustomerId,
    };
  },
};
</script>
<style lang="scss">
</style>